import { payOrdersDocumentation } from '../../documentation';

export const PayOrders = () => {
  return (
    <>
      {payOrdersDocumentation.map((doc) => (
        <div id={doc.id} key={doc.id}>
          {doc.content}
        </div>
      ))}
    </>
  );
};
